<template>    
    <div id='mainheader' :class="'mainheader-' + $mode">        
        <div class="header">            
            <Slide @openMenu="handleOpenMenu" :width="$mode=='infomarkt' ? '250' : '300'" right>
                <router-link to="/top">
                    <span class='icon'>
                        <font-awesome-icon icon="home" :style="{ color: 'white' }"/>
                    </span>
                    <span>{{ topiclabel }}</span>
                </router-link>
            
                <div v-if="$mode=='ms'" class="header-topics">
                    <router-link :to="route(-1, false)">
                        <span class='icon'>
                            <font-awesome-icon icon="layer-group" :style="{ color: 'white' }"/>
                        </span>
                        <span>{{getAllTopicLabel()}}</span> 
                    </router-link>
                </div>

                <div id="header-topiclist" v-for="item in menuitems" :key="item.id" class="header-topics">
                    <router-link v-if="$mode=='ms'" :to="route(item.id, item.top)">
                        <span class='icon'>
                            <font-awesome-icon icon="hashtag" :style="{ color: 'white' }"/>
                        </span>
                        <span>{{stripLabel(item.label)}}</span>                                
                    </router-link>
                </div>                            
                <!-- Überflüssig, da ohne Login ohnehin hierher weitergeleitet wird
                <router-link v-if="!this.$ms.isLoggedIn()" to="/login">
                    <span class='icon'>
                        <font-awesome-icon icon="user" :style="{ color: 'white' }"/>
                    </span>
                    <span>Login</span>
                </router-link>
                -->
                <a v-if="$mode=='infomarkt'" href='https://neu.infomarkt-shop.de/?digisubscribe'>
                    <span class='icon'>
                        <font-awesome-icon icon="shopping-bag" :style="{ color: 'white' }"/>
                    </span>
                    <span>Abonnieren</span>
                </a>
                <!--
                <router-link to="/">
                    <span class='icon'>
                        <font-awesome-icon icon="file-download" :style="{ color: 'white' }"/>
                    </span>
                    <span>Später Lesen</span>
                </router-link>
                -->
                <router-link to="/messages">
                    <span class='icon'>
                        <font-awesome-icon icon="envelope" :style="{ color: 'white' }"/>
                    </span>
                    <span>Nachrichten</span>
                    <span v-if='$parent.messages && $parent.messages > 0' class='badge'>
                        {{ $parent.messages }}
                    </span>
                </router-link>
                <router-link :to="{ name: 'Settings', params: {backlink: $router.currentRoute.path } }">
                    <span class='icon'>
                        <font-awesome-icon icon="cog" :style="{ color: 'white' }"/>
                    </span>
                    <span>Einstellungen</span>
                </router-link>                
                <router-link id='header-slide-second' :to="{ name: 'Webbook', params: { node: 'impressum' } }">
                    <span class='icon'>
                        <font-awesome-icon icon="info" :style="{ color: 'white' }"/>
                    </span>
                    <span>Impressum</span>
                </router-link>
                <router-link :to="{ name: 'Webbook', params: { node: 'stob' } }">
                    <span class='icon'>
                        <font-awesome-icon icon="info" :style="{ color: 'white' }"/>
                    </span>
                    <span>AGB</span>
                </router-link>
                <router-link :to="{ name: 'Webbook', params: { node: 'privacy' } }">
                    <span class='icon'>
                        <font-awesome-icon icon="info" :style="{ color: 'white' }"/>
                    </span>
                    <span>Datenschutz</span>
                </router-link>
                <router-link v-if="$mode=='infomarkt'" :to="{ name: 'Webbook', params: { node: 'revocation' } }">
                    <span class='icon'>
                        <font-awesome-icon icon="info" :style="{ color: 'white' }"/>
                    </span>
                    <span>Widerruf</span>
                </router-link>
            </Slide>      

            <div class='header-filter' v-if="this.$route.name == 'BaseListview' || (path.includes('/top/') && !path.includes('/post/'))">
                <button v-on:click="toggleFilter()">
                    {{ getFilterLabel() }}
                </button>
            </div>
            
            <div class="logobar">
                <img :src="'img/logo/logo-' + $mode + '.png'"/>
            </div>

            <router-link class='header-navigate' v-if="$parent.backlink && $parent.backlink.length && !$parent.$router.currentRoute.path.toLowerCase().includes('node')" :to="$parent.backlink">
                <font-awesome-icon :icon="($mode=='infomarkt') ? 'arrow-left' : 'chevron-left'" :style="{ color: 'white' }"/>
            </router-link>
            <span class='header-navigate' v-if="$parent.$router.currentRoute.path.toLowerCase().includes('node')">
                <font-awesome-icon icon="info" :style="{ color: 'white' }"/>
            </span>
            
            <h2 v-bind:class="{ 'headline': true, 'extra-space': $parent.backlink ? $parent.backlink.length : 0 }">
                {{ getHeadline(this.path) }}
            </h2>  
            <span v-if='$parent.messages && $parent.messages > 0' class='header-badge'>
                {{ $parent.messages }}
            </span>

        </div>
        <transition name="list">
            <div id='header-filterlist' v-show="showFilter" v-on:click="toggleFilter()">
                <strong>Filtern nach Themengebiet</strong>
                <ul>
                    <li class="topicviewitems">
                        <router-link :to="route(this.$parent.$route.params.topid, false)">Alle Beiträge</router-link>
                    </li>
                    <li class="topicviewitems" v-for="item in $parent.subtopics" :key="item.id">
                        <router-link :to="route(item.id, item.top)">{{item.label}}</router-link>
                    </li>
                </ul>

            </div>
        </transition>

        <div id='header-filterinfo' v-if="path.includes('/top/') && !path.includes('/post/')">
            <span class='filter-btn' v-if="$parent.$route.params.subid && $parent.topicheaders[$parent.$route.params.subid]" v-on:click="toggleFilter()">
                <span class='caption'>
                    {{ getFilterCaption() }}
                </span>
                <span class='filter'>
                    {{ $parent.topicheaders[$parent.$route.params.subid] }}
                </span>
            </span>            
            <!--<div v-else>Filter: Alle Beiträge</div>-->
        </div>
    </div>
</template>

<script>
import { Slide }  from 'vue-burger-menu' 
import MS_CONST from '../msclasses/msconst.js'
 
export default {
    name: 'Header',
    props: {
        path: String
    },
    data() {
        return { 
            headline: '',
            topiclabel: MS_CONST.LABEL_TOPICS,
            showFilter: false,
            menuitems: []
        }
    },
    components: {
        Slide
    },
    mounted() {
        require('../assets/css/Header.css')
        try { require('../assets/css/' + this.$mode + '/Header.css') } catch (e) {}
    },
    created() {
        // this.headline = this.getHeadline(this.path);        
        if (!this.menuitems.length)
            this.getTopilist();
    },
    updated() {
        if (!this.menuitems.length && this.$ms.isLoggedIn())
            this.getTopilist();
    },
    watch: {
        // path: function (newPath, oldPath) {
        //     //this.$log.trace('Path from to', oldPath, newPath);
        //     this.headline = this.getHeadline(newPath);
        // }
    },
    methods: {
        handleOpenMenu() {
            this.hideFilter();
        },
        getFilterlink() {
            return '/top/' + this.$parent.$route.params.topid + '/filter';
        },
        getFilterLabel() {
            return MS_CONST.LABEL_FILTER;
        },
        getFilterCaption() {
            return MS_CONST.LABEL_FILTERBTN;
        },
        getAllTopicLabel() {
            return MS_CONST.LABEL_ALLTOPICS;
        },
        getHeadline(path) {            
            var par = this.$parent;
            if (this.$route.name == 'Messageview')
                return MS_CONST.LABEL_MESSAGES;
            if (this.$route.name == 'Webbook' && path.includes("/welcome"))
                return MS_CONST.LABEL_WELCOME;
            if (this.$route.name == 'Webbook' && path.includes("/impressum"))
                return MS_CONST.LABEL_IMPRESSUM;
            if (this.$route.name == 'Webbook' && path.includes("/stob"))
                return MS_CONST.LABEL_STOB;
            if (this.$route.name == 'Webbook' && path.includes("/privacy"))
                return MS_CONST.LABEL_PRIVACY;
            if (this.$route.name == 'Webbook' && path.includes("/revocation"))
                return MS_CONST.LABEL_REVOCATION;
            if (this.$route.name == 'Login')
                return MS_CONST.LABEL_LOGIN;
            if (this.$route.name == 'Subscribe')
                return MS_CONST.LABEL_SUBSCRIBE;
            if (this.$route.name == 'Settings')
                return MS_CONST.LABEL_SETTINGS;
            if (this.$route.name == 'Errorpage')
                return MS_CONST.LABEL_ERROR;
            if (path.includes("/post/")) {                
                if (path.includes("/top/-1"))
                    return MS_CONST.LABEL_ALLTOPICS;
                let label = par.topicheaders[par.$route.params.topid];
                if (label)
                    return this.stripLabel(label);                 
                return MS_CONST.LABEL_DETAILVIEW;
            }
            // if (path.includes("/sub/")) {                
            //     let label = par.topicheaders[par.$route.params.subid];
            //     if (label) return label; 
            //     return MS_CONST.LABEL_LISTVIEW;
            // }
            if (path.includes("/top/")) {
                if (path.includes("/top/-1"))
                    return MS_CONST.LABEL_ALLTOPICS;
                let label = par.topicheaders[par.$route.params.topid];
                if (label) 
                    return this.stripLabel(label); 
                return MS_CONST.LABEL_TOPICS;
            }
            if (this.$route.name == 'BaseTopicview' || this.$route.name == 'Topicview')
                return MS_CONST.LABEL_TOPICS;
            if (this.$route.name == 'BaseListview')
                return MS_CONST.LABEL_ALLTOPICS;
            return MS_CONST.LABEL_TOPICS;
        },
        getTopilist() {
            var self = this;
            this.$ms.loadCacheLogin(function(login) {
                if (login && login.topiclist) {                        
                    self.$log.debug('Header: Build topic items.');
                    self.menuitems = [];                        
                    login.topiclist.forEach(function(item) {
                        if (item.list_id == -1) return; // Menüpunkt ##ALL## ausfiltern
                        var subtopics = [];
                        item.subtopiclist.forEach(function(subitem) {
                            subtopics.push({ label: subitem.list_label, id: subitem.list_id, top: item.list_id });
                            self.$parent.topicheaders[subitem.list_id] = subitem.list_label;
                        });
                        self.menuitems.push({ label: item.list_label, id: item.list_id, top: false, subtopics: subtopics });
                        self.$parent.topicheaders[item.list_id] = item.list_label;
                    });
                }
                else    
                    self.$log.debug('Header: Keine Topicliste');
            });
        },
        toggleFilter() {
            this.showFilter = !this.showFilter;
        },
        hideFilter() {
            this.showFilter = false;
        },
        route(id, top) {
            if (top)
                return "/top/" + top + '/sub/' + id;
            return "/top/" + id;
        },
        stripLabel(label) {
            let n = label.indexOf("@Markt");
            //this.$log.debug('label found=',label,',pos=', n);
            if (n != -1) {
                label = label.substring(0, n);
            }
            return label; 
        }
    }
}
</script>

<style/>>
